/*
 * ********************************************************************
 *  GlobePayroll Confidential
 *
 *  COPYRIGHT ©2016 by GlobePayroll. All Rights Reserved.
 *
 *   NOTICE:  All information contained herein is, and remains the property of GlobePayroll.
 *   The intellectual and technical concepts contained herein are proprietary to GlobePayroll
 *   and may be covered by U.S. and Foreign Patents, patents in process, and are protected by
 *   trade secret or copyright law.
 *   Dissemination of this information or reproduction of this material is strictly forbidden
 *   unless prior written permission is obtained from GlobePayroll.
 *  ********************************************************************
 */

import {CommonModule, NgIf} from '@angular/common';
import {NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {RouterModule, Routes} from '@angular/router';

import {TranslateModule} from '@ngx-translate/core';

import {ReportAnalyticsComponent} from './analytics/report-analytics.component';
import {ReportAnalyticsService} from './analytics/report-analytics.service';
import {ColumnItemComponent} from './column/column-item.component';
import {ReportResultComponent} from './column/report-result.component';
import {ElasticQueryService} from './elasticquery.service';
import {FilterItemComponent} from './filter/filter-item.component';
import {ReportFilterComponent} from './filter/report-filter.component';
import {Preview} from './preview';
import {ReportListComponent} from './report-list/report-list.component';
import {ReportManageComponent} from './report-manage.component';
import {ReportTopCardComponent} from './report-top-card/report-top-card.component';
import {ReportComponent} from './report.component';
import {ReportsService} from './reports.service';
import {ReportTimeComponent} from './time/report-time.component';

import {CollapseModule} from 'ngx-bootstrap/collapse';
import {NgxSelectModule} from 'ngx-select-ex';
import {TimeAndAttendanceService} from '../+payrolls/prepare/time/time-and-attendance.service';
import {EmployeeVariablesService} from '../+payrolls/prepare/variable-elements/employee-variables.service';
import {
  ReportGroupedResultItemComponent
} from '../+reports/report-grouped-result-item/report-grouped-result-item.component';
import {ReportSummaryRowComponent} from '../+reports/report-summary-row/report-summary-row.component';
import {AuthenticationGuard} from '../shared/authentication/authentication-guard';
import {ChartsModule} from '../shared/charts/charts.module';
import {RouteGuard} from '../shared/authentication/roles/route-guard';
import {EmployeeFormModule} from '../shared/employee-form/employee-form.module';
import {GpHotTableModule} from '../shared/hot-table/gp-hot-table.module';
import {ModalModule} from '../shared/modal/modal.module';
import {PipesModule} from '../shared/pipes/pipes.module';
import {CanDeactivateGuard} from '../shared/routing/can-deactivate-guard';
import {AddFieldsModalModule} from '../shared/ui/add-fields-modal/add-fields-modal.module';
import {DropdownTreeviewModule} from '../shared/ui/tree-multi-select/dropdown-treeview.module';
import {UiModule} from '../shared/ui/ui.module';
import {UserModule} from '../shared/user/user.module';

const routes: Routes = [
  {
    path: 'manage',
    component: ReportComponent,
    canActivate: [AuthenticationGuard],
    children: [
      {
        path: '',
        component: ReportManageComponent,
        canActivate: [RouteGuard]
      },
      {
        path: ':id',
        component: ReportManageComponent,
        canActivate: [RouteGuard],
        canDeactivate: [CanDeactivateGuard]
      }
    ]
  }
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    UiModule,
    ReactiveFormsModule,
    UserModule,
    TranslateModule,
    AddFieldsModalModule,
    DropdownTreeviewModule,
    NgxSelectModule,
    ModalModule,
    PipesModule,
    RouterModule.forChild(routes),
    GpHotTableModule,
    EmployeeFormModule,
    CollapseModule,
    ChartsModule,
    NgIf
  ],
  declarations: [
    ReportManageComponent,
    ReportAnalyticsComponent,
    ReportGroupedResultItemComponent,
    ReportSummaryRowComponent,
    ReportTopCardComponent,
    ReportFilterComponent,
    ReportTimeComponent,
    ReportResultComponent,
    FilterItemComponent,
    ColumnItemComponent,
    ReportComponent,
    ReportListComponent
  ],
  exports: [
    RouterModule,
    ReportListComponent,
    ReportFilterComponent,
    FilterItemComponent
  ],
  providers: [
    ReportsService,
    ElasticQueryService,
    ReportAnalyticsService,
    Preview,
    EmployeeVariablesService,
    TimeAndAttendanceService
  ]
})

export class ReportsModule {
}
